import { useEffect } from "react";
import { Container, Row } from "reactstrap";
import NavClass from "./NavClass/NavClass";
import TabClass from "./TabClass/TabClass";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { Apps, Tasks } from "../../../Constants/Constants";
import { Breadcrumbs } from "../../../AbstractElements";
import { fetchTaskApiData, setActiveTab } from "../../../ReduxToolkit/Reducers/TaskSlice";

const TaskContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchTaskApiData());
  }, [dispatch]);
  const activeToggle = (tab: string) => dispatch(setActiveTab(tab));

  return (
    <>
      <Breadcrumbs mainTitle={Tasks} parent={Apps} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <NavClass activeToggle={activeToggle} />
            <TabClass />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TaskContainer;
